/**
 * Payment progress bar — shows how much of an invoice has been paid.
 */
export default function ProgressBar({ paid, total, className = '' }) {
  if (!total || total <= 0) return null
  const pct = Math.min(100, Math.max(0, (paid / total) * 100))
  const remaining = total - paid

  const color = pct >= 100 ? 'bg-emerald-500' : pct > 0 ? 'bg-amber-500' : 'bg-gray-300'

  return (
    <div className={`space-y-1 ${className}`}>
      <div className="flex items-center justify-between text-xs">
        <span className="text-gray-500">{Math.round(pct)}% paid</span>
        {remaining > 0 && (
          <span className="text-gray-500 font-medium">
            {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(remaining)} due
          </span>
        )}
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
